module.exports = {
  siteMetadata: {
    title: 'Boilerplate',
    description: 'Starter website',
    siteUrl: 'https://richypears.com',
    author: 'Richy Pears',
    baseUrl: 'https://richypears.com',
    postAuthor: 'Richy Pears',
  },
  pathPrefix: '/',
  plugins: [
    {
      resolve: 'gatsby-source-storyblok',
      options: {
        accessToken: 'ira3EbRfDmWs5tm2yrzUhAtt',
        resolveLinks: true,
        homeSlug: 'home',
        version: process.env.NODE_ENV === `production` ? `published` : `draft`,
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: 'Boilerplate',
        short_name: 'Boilerplate',
        description: 'Boilerplate',
        homepage_url: 'https://richypears.com',
        start_url: '/',
        background_color: '#fff',
        theme_color: '#ffcc00',
        display: 'standalone',
        icon: 'src/icons/icon.svg',
      },
    },
    {
      resolve: `gatsby-plugin-gdpr-cookies`,
      options: {
        googleAnalytics: {
          trackingId: '', // leave empty if you want to disable the tracker
          cookieName: 'otherthings-gdpr-google-analytics', // default
          anonymize: true, // default
          allowAdFeatures: false, // default
        },
        googleTagManager: {
          trackingId: '', // leave empty if you want to disable the tracker
          cookieName: 'otherthings-gdpr-google-tagmanager', // default
          dataLayerName: 'dataLayer', // default
        },
        facebookPixel: {
          pixelId: '', // leave empty if you want to disable the tracker
          cookieName: 'otherthings-gdpr-facebook-pixel', // default
        },
        // defines the environments where the tracking should be available  - default is ["production"]
        environments: ['production', 'development'],
      },
    },
    {
      resolve: 'gatsby-plugin-netlify',
      options: {
        headers: {
          '/*': [
            'Content-Security-Policy: frame-ancestors https://app.storyblok.com/',
          ],
        },
        mergeSecurityHeaders: true,
        mergeLinkHeaders: true,
        mergeCachingHeaders: true,
      },
    },
    'gatsby-plugin-catch-links',
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-sass',
    'gatsby-plugin-sharp',
    'gatsby-plugin-sitemap',
    'gatsby-transformer-sharp',
  ],
};
